export default __webpack_public_path__ + "static/media/clientes.701b1152.png";